export const APP_VERSION = "1.2.0";
export const APP_BUILD = "20261001.1";
export const APP_VERSION_LABEL = `v${APP_VERSION} · ${APP_BUILD}`;
